import React from "react";
import {
  FaRobot,
  FaChartLine,
  FaWind,
  FaBolt,
  FaLightbulb,
  FaLeaf,
} from "react-icons/fa";
import Solution1 from "../Assets/solutions.png"
import Solution2 from "../Assets/solution2.png"

function Solutions() {
const solutionCards = [
  {
    number: "01",
    title: "Automation & Digital Factory Solutions",
    description:
      "Smart automation solutions designed to improve machine performance, process visibility and production efficiency across industrial environments.",
    points: [
      "PLC-based machine and line automation",
      "HMI and SCADA-based monitoring systems",
      "Robotics-driven automation solutions",
      "Smart factory and e-factory implementations",
    ],
    color: "#8E3AAE",
    icon: <FaRobot size={54} />,
  },
  {
    number: "02",
    title: "Energy Monitoring & Power Quality",
    description:
      "Advanced monitoring and protection solutions that help industries measure energy usage, improve quality and optimize power consumption.",
    points: [
      "Power meters and monitoring systems",
      "Energy analytics and consumption optimization",
      "Voltage, current and phase protection systems",
      "Better visibility into electrical performance",
    ],
    color: "#F05A28",
    icon: <FaChartLine size={54} />,
  },
  {
    number: "03",
    title: "Daylighting & Ventilation Solutions",
    description:
      "Solutions that improve indoor environments through natural light harvesting and efficient ventilation support.",
    points: [
      "Prismatic daylighting systems",
      "Lightpipe daylight harvesting solutions",
      "Smart roof exhaust systems",
      "Ventilation-focused industrial applications",
    ],
    color: "#2D9CDB",
    icon: <FaWind size={54} />,
  },
  {
    number: "04",
    title: "Energy-Efficient Motors, Fans & Drives",
    description:
      "High-efficiency motion and airflow solutions that support reduced energy consumption and better operational performance.",
    points: [
      "BLDC ceiling, HVLS and industrial fans",
      "BLDC motors for industrial, EV and solar applications",
      "IoT-ready and hybrid power solutions",
      "Energy-conscious drive systems",
    ],
    color: "#8E3AAE",
    icon: <FaBolt size={54} />,
  },
  {
    number: "05",
    title: "Advanced Industrial & Commercial Lighting",
    description:
      "Lighting solutions developed for industrial, commercial and specialized spaces with efficiency, reliability and automation readiness in mind.",
    points: [
      "Driver-less LED lighting systems",
      "Industrial highbays and street lighting",
      "Hospital, commercial and façade lighting",
      "Solar-ready and automation-ready lighting",
    ],
    color: "#35B8C8",
    icon: <FaLightbulb size={54} />,
  },
  {
    number: "06",
    title: "Emission Control & Environmental Solutions",
    description:
      "Solutions focused on reducing harmful emissions and helping organizations improve environmental compliance and sustainability outcomes.",
    points: [
      "Retrofit Emission Control Devices for DG sets",
      "PM, HC, CO and NOx reduction solutions",
      "Certified emission technology support",
      "Cleaner and more compliant operations",
    ],
    color: "#EF2E2E",
    icon: <FaLeaf size={54} />,
  },
];

  const industries = [
    "Manufacturing",
    "Utilities",
    "Infrastructure",
    "Commercial Facilities",
    "Industrial Plants",
    "Sustainable Development Projects",
  ];

  return (
    <div style={{ backgroundColor: "#f7fbff", overflowX: "hidden" }}>
    <section
  style={{
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 45%, #f7fbff 100%)",
    padding: "90px 0 70px 0",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: "30px",
      left: "-70px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    style={{
      position: "absolute",
      bottom: "20px",
      right: "-60px",
      width: "240px",
      height: "240px",
      borderRadius: "50%",
      background: "rgba(11,92,173,0.10)",
      filter: "blur(10px)",
      animation: "floatY 6s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      <div className="col-lg-6">
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e6f4ff",
            color: "#0B5CAD",
            padding: "10px 18px",
            borderRadius: "30px",
            fontWeight: 700,
            fontSize: "14px",
            marginBottom: "18px",
            animation: "fadeUp 1s ease",
          }}
        >
          SOLUTIONS WE OFFER
        </div>

        <h1
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
            lineHeight: "1.15",
            marginBottom: "18px",
            animation: "fadeUp 1.1s ease",
          }}
        >
          Practical Solutions
          <br />
          For Smarter Operations
        </h1>

        <p
          style={{
            color: "#4a5568",
            fontSize: "17px",
            lineHeight: "1.9",
            marginBottom: "24px",
            animation: "fadeUp 1.2s ease",
          }}
        >
          Electromates provides solution-led engineering across automation,
          energy monitoring, ventilation, lighting, motor efficiency and
          environmental performance to help industries operate more
          intelligently and sustainably.
        </p>

        <div className="row g-3">
          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                6
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Solution Areas
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Smart
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Industry Solutions
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Future
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Ready Systems
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            position: "relative",
            zIndex: 1,
            borderRadius: "28px",
            overflow: "hidden",
            animation: "zoomInSoft 1.2s ease",
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={Solution1}
            alt="Solutions"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section className="py-5" style={{ backgroundColor: "#ffffff" }}>
  <div className="container py-4">
    <div className="text-center mb-5">
      <h2
        style={{
          color: "#0B5CAD",
          fontWeight: 800,
          marginBottom: "12px",
          fontSize: "clamp(2rem, 4vw, 2.7rem)",
        }}
      >
        Solution Portfolio
      </h2>

      <p
        style={{
          maxWidth: "860px",
          margin: "0 auto",
          color: "#5b6777",
          lineHeight: "1.8",
          fontSize: "16px",
        }}
      >
        Our solution offerings are designed to help customers improve
        performance, visibility, efficiency and sustainability across a wide
        range of industrial and infrastructure applications.
      </p>
    </div>

    <div className="row g-4">
      {solutionCards.map((item, index) => {
        const isEven = index % 2 === 0;

        return (
          <div className="col-lg-6" key={index}>
            <div
              style={{
                display: "flex",
                flexDirection: isEven ? "row" : "row-reverse",
                alignItems: "stretch",
                backgroundColor: "#ffffff",
                border: `2px solid ${item.color}`,
                borderRadius: "34px",
                overflow: "hidden",
                minHeight: "220px",
                boxShadow: "0 10px 24px rgba(0,0,0,0.07)",
                height: "100%",
              }}
            >
              <div
                style={{
                  width: "130px",
                  minWidth: "130px",
                  backgroundColor: item.color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  padding: "18px 12px",
                }}
              >
                <div
                  style={{
                    width: "78px",
                    height: "78px",
                    borderRadius: "50%",
                    border: "2px solid rgba(255,255,255,0.75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255,255,255,0.08)",
                  }}
                >
                  {item.icon}
                </div>
              </div>

              <div
                style={{
                  flex: 1,
                  padding: "18px 20px 16px 20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  backgroundColor: "#ffffff",
                }}
              >
                <h3
                  style={{
                    color: item.color,
                    fontWeight: 800,
                    marginBottom: "8px",
                    fontSize: "20px",
                    lineHeight: "1.25",
                  }}
                >
                  {item.title}
                </h3>

                <p
                  style={{
                    color: "#5b6777",
                    lineHeight: "1.6",
                    marginBottom: "10px",
                    fontSize: "13.5px",
                  }}
                >
                  {item.description}
                </p>

                <ul
                  style={{
                    margin: 0,
                    paddingLeft: "18px",
                  }}
                >
                  {item.points.map((point, i) => (
                    <li
                      key={i}
                      style={{
                        color: "#2f3b4b",
                        lineHeight: "1.5",
                        marginBottom: "4px",
                        fontSize: "13.5px",
                      }}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>
      <section
        className="py-5"
        style={{
          background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
        }}
      >
        <div className="container py-4">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "24px",
                  padding: "34px",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
                  borderLeft: "6px solid #1DA9E8",
                }}
              >
                <h2
                  style={{
                    color: "#0B5CAD",
                    fontWeight: 800,
                    marginBottom: "18px",
                  }}
                >
                  Why These Solutions Matter
                </h2>

                <p style={{ color: "#4a5568", lineHeight: "1.95" }}>
                  Electromates’ solutions are built to address both operational
                  and sustainability goals. From factory automation and energy
                  analytics to airflow, lighting and emission improvement, each
                  solution area supports smarter long-term industrial
                  performance.
                </p>

                <p
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.95",
                    marginBottom: 0,
                  }}
                >
                  This solution-driven approach helps organizations reduce
                  inefficiencies, improve process control, increase visibility
                  and move toward cleaner, more efficient systems.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
  <div
    style={{
      minHeight: "340px",
      borderRadius: "24px",
      overflow: "hidden",
    }}
  >
    <img
      src={Solution2}
      alt="Application Deployment"
      style={{
        width: "100%",
        height: "340px",
        objectFit: "cover",
        display: "block",
      }}
    />
  </div>
</div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container py-4">
          <h2
            style={{
              color: "#0B5CAD",
              fontWeight: 800,
              marginBottom: "24px",
              textAlign: "center",
            }}
          >
            Industries & Applications
          </h2>

          <div className="row g-3">
            {industries.map((item, index) => (
              <div className="col-sm-6 col-lg-4" key={index}>
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "18px",
                    padding: "20px",
                    boxShadow: "0 8px 20px rgba(11,92,173,0.06)",
                    color: "#2d3748",
                    fontWeight: 600,
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container py-4">
          <div
            style={{
              background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
              borderRadius: "28px",
              padding: "50px 30px",
              textAlign: "center",
              color: "#ffffff",
              boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
            }}
          >
            <h2 style={{ fontWeight: 800, marginBottom: "14px" }}>
              Need the Right Solution for Your Application?
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto 24px",
                lineHeight: "1.85",
                color: "rgba(255,255,255,0.92)",
              }}
            >
              Electromates helps organizations choose and implement practical,
              scalable and sustainable solutions tailored to real operational
              needs.
            </p>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Solutions;